export default "__VITE_ASSET__DstKywEf__"